<template>
    <div class="c-m-card c-m-card--compact c-m-card--with-actions">
        <div class="c-m-card__content">
            <div class="c-m-card__headline">
                <h3 class="c-m-card__title h4"><router-link :to="link">{{title}}</router-link></h3>
            </div>
            <div class="c-m-card__byline">
                <span class="c-m-card__byline-item" v-if="date"><icon :icon="'calendar'"></icon>{{date}}</span>
                <span class="c-m-card__byline-item" v-if="place"><icon :icon="'pin_drop'"></icon>{{place}}</span>
                <span class="c-m-card__byline-item" v-if="category"><icon :icon="'hammer_and_wrench'"></icon>{{category}}</span>
            </div>
            <p v-if="description" class="c-m-card__body" v-html="description"></p>
        </div>
        <div class="c-m-card__actions">
            <button-link class="c-a-button--circle c-m-card__button" :link="link" :icon="icon" aria-label="Fortsätt"></button-link>
        </div>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex'
    import { GET_REGIONS, GET_CERTIFICATES} from '../../../store/store-models/filters-model';

    import filters from '../../../filters/index.js';
    import ButtonLink from '../atoms/AtomButtonLink.vue';
    import AtomRating from '../atoms/AtomRating.vue';
    import Icon from '../atoms/AtomIcon.vue';

    export default {
        data() {
            return {
                icon: 'arrow_forward',
                defaultImage: 'Brabyggare-logo.png',
                showTooltip: false
            }
        },
        props: [
            'request',
            'horizontalLayout',
        ],
        components: {
            ButtonLink,
            AtomRating,
            Icon
        },
        computed:{
            ...mapGetters({
                regions: GET_REGIONS,
                certificateMeta: GET_CERTIFICATES
            }),
            featuredImage: function() {
                return this.request.Images.length ? this.request.Images[0] : null;
            },
            altText: function() {
                return ''
            },
            link: function() {
                return '/forfragan/' + this.request.Id;
            },
            title: function() {
                return this.request.Title;
            },
            date: function() {
                return filters.formatDateWithoutTime(this.request.CreatedDate);
            },
            category: function() {
                return this.request.Category.Name
            },
            place: function() {
                return this.request.Region.Name
            },
            description:function() {
                return this.request.Presentation ? filters.truncate(filters.stripHTML(this.request.Presentation), 300, true) : '';
            },
            ratings: function() {
                return this.request.Rating;
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/views/components/molecules/MoleculeCardRequest.vue